var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoedbeginAchieved(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 148.21 134.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        opacity: .5;\n      }\n\n      .cls-4 {\n        fill: url(#New_Gradient_Swatch_copy_5-4);\n      }\n\n      .cls-4, .cls-5, .cls-6 {\n        mix-blend-mode: overlay;\n      }\n\n      .cls-2 {\n        fill-rule: evenodd;\n      }\n\n      .cls-5 {\n        fill: url(#New_Gradient_Swatch_copy_5-3);\n      }\n\n      .cls-7 {\n        isolation: isolate;\n      }\n\n      .cls-6 {\n        fill: url(#New_Gradient_Swatch_copy_5-2);\n      }\n\n      .cls-8 {\n        opacity: .75;\n      }\n\n      .cls-9 {\n        fill: none;\n      }\n\n      .cls-10 {\n        fill: url(#New_Gradient_Swatch_copy_5);\n        stroke: url(#linear-gradient);\n        stroke-miterlimit: 10;\n        stroke-width: 10px;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_5",
    "data-name": "New Gradient Swatch copy 5",
    x1: 5,
    y1: 67.18,
    x2: 143.21,
    y2: 67.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fedb4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb11a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0,
    y1: 67.18,
    x2: 148.21,
    y2: 67.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#feb11a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fedb4a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_5-2",
    "data-name": "New Gradient Swatch copy 5",
    x1: 5,
    y1: 67.18,
    x2: 143.21,
    y2: 67.18,
    xlinkHref: "#New_Gradient_Swatch_copy_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_5-3",
    "data-name": "New Gradient Swatch copy 5",
    x1: 13.97,
    y1: 68.06,
    x2: 143.21,
    y2: 68.06,
    xlinkHref: "#New_Gradient_Swatch_copy_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_5-4",
    "data-name": "New Gradient Swatch copy 5",
    x1: 34.72,
    y1: 85.6,
    x2: 143.21,
    y2: 85.6,
    xlinkHref: "#New_Gradient_Swatch_copy_5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m99.95,5h-51.69c-6.22,0-11.97,3.32-15.08,8.71L7.33,58.47c-3.11,5.39-3.11,12.03,0,17.42l25.85,44.77c3.11,5.39,8.86,8.71,15.08,8.71h51.69c6.22,0,11.97-3.32,15.08-8.71l25.85-44.77c3.11-5.39,3.11-12.03,0-17.42l-25.85-44.77c-3.11-5.39-8.86-8.71-15.08-8.71Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m140.88,75.89l-23.44,40.59-2.41,4.18c-3.11,5.39-8.86,8.71-15.08,8.71h-51.69c-5.31,0-10.29-2.42-13.54-6.49-.58-.69-1.09-1.43-1.54-2.22l-2.41-4.18-16.8-29.09-6.64-11.5c-3.11-5.38-3.11-12.02,0-17.41L33.18,13.71c3.11-5.39,8.86-8.71,15.08-8.71h51.69c2.68,0,5.28.62,7.61,1.76,3.08,1.49,5.7,3.89,7.47,6.95l16.24,28.13,9.61,16.64c3.11,5.39,3.11,12.03,0,17.41Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m140.88,75.89l-23.44,40.59-2.41,4.18c-3.11,5.39-8.86,8.71-15.08,8.71h-51.69c-5.31,0-10.29-2.42-13.54-6.49-.58-.69-1.09-1.43-1.54-2.22l-2.41-4.18-16.8-29.09C51.58,64.48,83.82,38.25,107.56,6.76c3.08,1.49,5.7,3.89,7.47,6.95l16.24,28.13,9.61,16.64c3.11,5.39,3.11,12.03,0,17.41Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m140.88,75.89l-23.44,40.59-2.41,4.18c-3.11,5.39-8.86,8.71-15.08,8.71h-51.69c-5.31,0-10.29-2.42-13.54-6.49,3.41-1.8,6.78-3.64,10.08-5.51,2.94-1.66,5.83-3.35,8.67-5.07h0c2.43-1.47,4.82-2.95,7.18-4.47,2.44-1.55,4.85-3.13,7.22-4.75,3.32-2.24,6.56-4.53,9.74-6.87,21.39-15.78,39.52-33.74,53.66-54.37l9.61,16.64c3.11,5.39,3.11,12.03,0,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m140.88,75.89l-23.44,40.59-2.41,4.18c-3.11,5.39-8.86,8.71-15.08,8.71h-51.69c-5.31,0-10.29-2.42-13.54-6.49-.58-.69-1.09-1.43-1.54-2.22l-2.41-4.18-16.8-29.09-6.64-11.5c-3.11-5.38-3.11-12.02,0-17.41L33.18,13.71c3.11-5.39,8.86-8.71,15.08-8.71h51.69c2.68,0,5.28.62,7.61,1.76,3.08,1.49,5.7,3.89,7.47,6.95l16.24,28.13,9.61,16.64c3.11,5.39,3.11,12.03,0,17.41Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m93.57,57.15c0,4.89-.51,8.43-1.4,11,7.33,15.2-.41,29.18-.41,29.18l-8.79-7.95s-.65,2.65-1.77,2.65c-3.41,0-10.76,0-14.13,0-1.09,0-1.76-2.65-1.76-2.65l-8.83,7.95s-8.07-14.51,0-30.02c0,0-.88-5.65-.88-10.16,0-9.51,13.63-38.42,19.43-38.42,5.8,0,18.54,28.9,18.54,38.41h0Zm-18.99-19.87c-4.15,0-7.51,3.36-7.51,7.51,0,4.15,3.36,7.51,7.51,7.51,4.15,0,7.51-3.36,7.51-7.51,0-4.15-3.36-7.51-7.51-7.51h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m117.44,116.48l-2.41,4.18c-3.11,5.39-8.86,8.71-15.08,8.71h-51.69c-5.31,0-10.29-2.42-13.54-6.49-.58-.69-1.09-1.43-1.54-2.22l-2.41-4.18c1.67-1.78,4.03-2.89,6.65-2.89,3,0,5.71,1.47,7.38,3.78.18.24.35.49.5.75,1.69-1.26,3.93-1.8,6.05-1.37.39-1.64,1.13-3.15,2.12-4.45h0c1.75-2.28,4.28-3.9,7.18-4.47.75-.14,1.51-.22,2.3-.22.91,0,4.58.1,6.4.31-.55-1.6-1.05-3.27-1.48-4.84-1.04-3.74-1.71-6.87-1.71-6.87h15.9s-1.34,6.29-3.19,11.71c1.82-.21,5.49-.31,6.4-.31,5.6,0,10.33,3.87,11.6,9.14,2.11-.43,4.36.11,6.05,1.37,1.6-2.73,4.57-4.53,7.88-4.53,2.62,0,4.98,1.11,6.64,2.89Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 69.75,
    y: 5.01,
    width: 10.54,
    height: 13.72
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoedbeginAchieved);
export default __webpack_public_path__ + "static/media/goed begin_achieved.d65fe136f439169c508c967996041027.svg";
export { ForwardRef as ReactComponent };